module.exports = __webpack_public_path__ + "img/load.6099cc92.jpg";